import React from 'react';

import { SideResult } from './';
import { PRIMARY_KEY } from '../backend/model';
import { createPdf } from 'pdfmake/build/pdfmake';

export const MISide = ({overview, results, readIslandData, createPdf, saveIsland, pi, isAdmin}) => {
  //console.log('results:', results);
  let res = results.map((res, i) => {
    return <SideResult res={res} readIslandData={readIslandData} key={'res' + res.HISTOLITT_V2} />
  });


  return(
    <div className='result-panel shadow'>
      <div  className='flex-dir-column' style={{ display: !!overview ? 'flex' : 'none'}}>
        <div className='result-header right shadow'>
          <p>Aperçu</p>
        </div>
        <div className='side-content flex-dir-column' id='mi-side-content'>
          <div className='flex-dir-column' style={{ padding: 8, paddingTop: 25 }}>
            <div className='flex-dir-column' style={{ display: 'block'}}>
              {
                !! overview.HISTOLITT_V2
                ? <div className='flex-dir-column' style={{ marginBottom: 8}}>
                    <span style={{color: 'grey'}}>Histolitt v2 :</span>
                    <span>
                      {overview.HISTOLITT_V2}
                    </span>
                  </div>
                : null
              }
              {
                !! overview.NOM_SHOM
                ? <div className='flex-dir-column' style={{ marginBottom: 8}}>
                    <span style={{color: 'grey'}}>Nom Shom :</span>
                    <span>
                      {overview.NOM_SHOM}
                    </span>
                  </div>
                : null
              }
              {
                !! overview.IGN
                ? <div className='flex-dir-column' style={{ marginBottom: 8}}>
                    <span style={{color: 'grey'}}>IGN :</span>
                    <span>
                      {overview.IGN}
                    </span>
                  </div>
                : null
              }
            </div>
            <span style={{ display: 'flex', alignSelf: 'center', justifySelf: 'flexEnd' }}>Cliquez pour en savoir plus</span>
          </div>
        </div>
      </div>
      <div className='flex-dir-column' style={{ display: overview ? 'none' : 'flex'}}>
        <div className='result-header right shadow'>
          <p id='header-title'>Bonjour</p>
        </div>
        <div className='side-content flex-dir-column' id='mi-side-content' >
          <div className='overflow flex-dir-column'  style={{ padding: 8}}>
            <div className='flex-dir-column' id='mi-side-welcome'>
              <p>Bienvenue sur le site Îles & Îlots</p>
              <p>Utilisez la carte pour découvrir une île, ou servez-vous de la barre de recherche pour faire des recherches spécifiques.</p>
            </div>
            <div className='flex-dir-column'>
              {res}
              {
                !!pi && isAdmin?
                <div className='flex-dir-column' style={{ display: 'flex', justifyContent: 'flex-end'}}>
                  <button className='regular-button' onClick={saveIsland}>Sauvegarder</button>
                  <button className='regular-button' onClick={createPdf}>PDF</button>
                </div>
              :
                null
              }
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
  

